<template>
  <div :class="$style['pt-order-form']" v-loading="customerLoading">
    <pt-form-list-item label="选择商城用户：" required>
      <wt-input :value="userIdsLength" data-vv-as="商城用户" v-validate="'required'" style="display:none"></wt-input>
      <select-user-fitter fromPage="promotion-form" :showBetchSelectUser="false" :selectUserList="selectUserList"
        @userSubmit="userSubmit" @importLoading="importLoading" :isShowTxt="false">
      </select-user-fitter>
    </pt-form-list-item>
    <pt-form-list-item label="选择商品：" required>
      <wt-input :value="goodsIdLength" data-vv-as="商品" v-validate="'required'" style="display:none">
      </wt-input>
      <el-button plain type="primary" @click="selectGoods">点击选择商品</el-button>
      <div class="page-background" :class="$style['goods-selected-table-show']" v-if="goods_list">
        <table :class="$style['goods-table']">
          <tr>
            <td>商品名称</td>
          </tr>
          <tr>
            <td>{{goods_list.goodsDTO&&goods_list.goodsDTO.goodsData&&goods_list.goodsDTO.goodsData.name}}</td>
          </tr>
        </table>
      </div>
    </pt-form-list-item>
    <pt-form-list-item label="选择规格：" required v-if="specificationsLabel.length">
      <wt-selector :options="specificationsLabel" v-model="formValue.specificationItem" data-vv-as="商品规格"
        v-validate="'required'" :props="specificationsProp">
      </wt-selector>
      <span style="margin-left:.2rem" v-if="price">￥{{price}}</span>
    </pt-form-list-item>
    <pt-form-list-item label="商品数量：" required>
      <wt-input-number :min="1" v-validate="'required|numeric|min_value:1|is_not:0'" data-vv-as="商品数量"
        controls-position="right" v-model="formValue.number"></wt-input-number>
    </pt-form-list-item>
    <pt-form-list-item label="订单价格：">
      <wt-input v-model="formValue.specifyAmount" type="number">
        <el-button slot="append">¥</el-button>
      </wt-input>
    </pt-form-list-item>
    <pt-receiving-message v-if="userIdsLength === 1 && isDeliverGoods" v-model="formValue.shippingAddress" ref="receiving"></pt-receiving-message>
    <pt-form-list-item label="是否需要发票：" v-if="formValue.specifyAmount !== '0' && provideInvoice && userIdsLength === 1">
      <wt-radio :radios="invoiceLabels" v-model="formValue.needInvoice"></wt-radio>
    </pt-form-list-item>
    <pt-invoice-message v-if="formValue.needInvoice" ref="invoice" :maxWidth="maxWidth"></pt-invoice-message>
    <el-button type="primary" @click="submit()">创建订单</el-button>
    <el-dialog :visible.sync="is_dialog" :title="dialog_title" @close="closeDialog">
      <select-for-goods @selectGoodsSubmit="selectGoodsSubmit" @close="closeDialog" :selected-goods="goods_list"
        :group-list="groupList" selectType="radio" :isRadioSelectButton="true">
      </select-for-goods>
    </el-dialog>
  </div>

</template>

<script>
import ptReceivingMessage from 'cps/base/pt-receiving-message'
import ptInvoiceMessage from 'cps/base/pt-invoice-message'
import {
  invoiceLabels
} from '../goods-order-options'
import selectForGoods from '../../mall-manage/select-for-goods'
import selectUserFitter from 'cps/base/select-user-fitter/index'
import formMixins from 'mixins/form'
import {
  cashCount
} from '@/utils/formUtils'
  // 组件class前缀
const prefixCls = 'pt-order-form'

export default {
  name: 'pt-order-form',
  mixins: [formMixins],
  props: {
    groupList: {
      type: Array,
      default: function () {
        return []
      }
    },
    customerLoading: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    invoice () {
      return this.$refs.invoice
    },
    receiving () {
      return this.$refs.receiving
    }
  },
  components: {
    ptInvoiceMessage,
    ptReceivingMessage,
    selectUserFitter,
    selectForGoods
  },
  data () {
    return {
      price: '',
      invoiceLabels: invoiceLabels,
      formValue: {
        needInvoice: false,
        specificationItem: '',
        number: 1
      },
      selectUserList: [],
      goods_list: null,
      is_dialog: false,
      dialog_title: '',
      showStockQuantity: false,
      disableSelect: false,
      maxWidth: '92',
      specificationsLabel: [],
      specificationsProp: {
        value: 'itemId',
        label: 'name'
      },
      userIdsLength: null,
      goodsIdLength: null,
      isDeliverGoods: false,
      provideInvoice: true
    }
  },
  watch: {
    // 选择商品
    goods_list: {
      handler: function (val) {
        this.isDeliverGoods = !(val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData.shippingMode === 'NONE')
        this.price = ''
        this.formValue.specificationItem = ''
        this.formValue.goodsId = val.goodsDTO && val.goodsDTO.id
        this.formValue.name = val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData.name
        this.provideInvoice = val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData.provideInvoice
        let specifications = (val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData
          .specifications && val.goodsDTO.goodsData.specifications[0] && val.goodsDTO.goodsData.specifications[0]
          .items && val.goodsDTO.goodsData.specifications[0].items) || null
        if (specifications) {
          this.specificationsLabel = specifications.map(e => {
            return {
              name: e.name,
              itemId: JSON.stringify(e)
            }
          })
        } else {
          this.specificationsLabel = []
        }
        this.goodsIdLength = (this.formValue.goodsId && this.formValue.goodsId.length > 0) ? this.formValue.goodsId
          .length : null
      }
    },
    // 选择用户
    selectUserList: {
      handler: function (val) {
        if (val) {
          if (val.userListId && val.ids.length) {
            let newWhiteList = []
            newWhiteList.push({ 'userListId': val.userListId })
            newWhiteList.push({ 'ids': val.ids })
            this.formValue.whiteList = newWhiteList
          } else {
            this.formValue.whiteList = val
          }
          this.userIdsLength = (val && val.ids && val.ids.length > 0) ? val
            .ids.length : null || (val && val.userListId) ? 0 : null
          if (val.userListId) {
            this.userIdsLength = 0
          }
        }
      }
    },
    'formValue.needInvoice': {
      handler (val) {
        this.$emit('isInvoice', val)
      }
    },
    'formValue.specificationItem': {
      handler (val) {
        if (val) {
          let changeVal = JSON.parse(val)
          this.price = cashCount(changeVal.price, true) * this.formValue.number
        }
      }
    },
    'formValue.number': {
      handler (val) {
        let currentPrice = JSON.parse(this.formValue.specificationItem)
        let price = cashCount(currentPrice.price, true)
        this.price = price * val
      }
    }
  },
  methods: {
    submit () {
      this.validate().then((res) => {
        if (this.userIdsLength === 1 && this.isDeliverGoods) {
          this.receiving.validate().then(_ => {
            this.receiving.addressForm.address.validate().then(_ => {
              if (this.formValue.needInvoice) {
                this.invoice.validate().then(_ => {
                  this.formValue.mallOrderInvoice = this.invoice.form
                  this.$emit('toSubmit', this.formValue)
                })
              } else {
                this.$emit('toSubmit', this.formValue)
              }
            })
          })
        } else if (this.formValue.needInvoice) {
          this.invoice.validate().then(_ => {
            this.formValue.mallOrderInvoice = this.invoice.form
            this.$emit('toSubmit', this.formValue)
          })
        } else {
          this.$emit('toSubmit', this.formValue)
        }
      })
    },
    importLoading (val) {
      this.customerLoading = val
    },
    closeDialog () {
      this.is_dialog = false
    },
    // 打开弹窗
    selectGoods () {
      this.is_dialog = true
      this.dialog_title = '选择商品'
    },
    // 选择完成
    selectGoodsSubmit (val) {
      this.is_dialog = false
      this.goods_list = val
    },
    userSubmit (val) {
      this.selectUserList = val
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-order-form {
    :global {
      .wt-input {
        width: 3rem;
      }
    }
  }

  .goods-table {
    display: table !important;
    width: 100%;
    border-collapse: collapse !important;

    th,
    tr {
      width: 100% !important;
      max-width: 100% !important;
      display: table-row;
      padding: 0 !important;
      list-style-type: none;
      border-bottom: 1px solid #ebeef5;
      color: #818181
    }

    td {
      text-align: center;
      padding: 15px;
    }
  }

  .goods-selected-table-show {
    margin: 30px 0;
    max-width: 500px;
  }

</style>
